import React__default from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../../Typography/Typography.js';
import { StyledMenuItemText } from './SideNavigationMenuItem.styles.js';

var SideNavigationMenuItemText = function SideNavigationMenuItemText(_ref) {
  var _ref$isTitle = _ref.isTitle,
    isTitle = _ref$isTitle === void 0 ? false : _ref$isTitle,
    children = _ref.children;
  var variant = isTitle ? 'headingRegular' : 'bodyRegular';
  return React__default.createElement(Typography, {
    as: StyledMenuItemText,
    variant: variant
  }, children);
};
SideNavigationMenuItemText.propTypes = {
  children: PropTypes.node.isRequired,
  isTitle: PropTypes.bool
};

export { SideNavigationMenuItemText, SideNavigationMenuItemText as default };
//# sourceMappingURL=SideNavigationMenuItemText.js.map
